<template>
<div class="tipsPage">
    <img src="../assets/img/warning.png" alt="提示">
    <p>请在微信客户端打开链接</p>
</div>
</template>

<script>
export default {
    name: 'tipsPage'
}
</script>

<style lang="less">
.tipsPage {
    width: 100%;
    height: 100%;
    padding-top: 400px;
    text-align: center;
    background: #fff;

    img {
        width: 190px;
        height: auto;
        margin-bottom: 60px;
    }

    p {
        margin-bottom: 10px;
        font-weight: 400;
        font-size: 38px;
        color: #000;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/tipsPage.vue